/* External dependencies */
import update from 'react-addons-update';
import { ISignUpResult } from 'amazon-cognito-identity-js';

/* Local dependencies */
import CustomCognitoUserSession from '@mancho.devs/cognito/lib/cognito-user-session';
import {
  AuthAction,
  SignInActionTypes,
  SignUpActionTypes,
  SignOutActionTypes,
  ConfirmCodeActionTypes,
  PasswordForgotActionTypes,
  ConfirmPasswordActionTypes,
  GetSessionActionTypes,
} from './actions';

export interface AuthorizationState {
  email: null | string;
  status: null | string;
  isSignOutButton: boolean;
  user: null | ISignUpResult;
  errorMessage: null | string;
  codeErrorMessage: null | string;
  signInErrorMessage: null | string;
  signOutErrorMessage: null | string;
  session: null | CustomCognitoUserSession;
  passwordForgotErrorMessage: null | string;
  confirmPasswordErrorMessage: null | string;
}

const initialState: AuthorizationState = {
  user: null,
  email: null,
  status: null,
  session: null,
  errorMessage: null,
  codeErrorMessage: null,
  isSignOutButton: false,
  signInErrorMessage: null,
  signOutErrorMessage: null,
  passwordForgotErrorMessage: null,
  confirmPasswordErrorMessage: null,
};

export function authorizationReducer(state: AuthorizationState = initialState, action: AuthAction) {
  switch (action.type) {
    case SignUpActionTypes.SIGNUP:
      return update(state, {
        status: { $set: 'loading' },
        errorMessage: { $set: null },
      });

    case SignUpActionTypes.SIGNUP_SUCCEEDED:
      return update(state, {
        user: { $set: action.result },
        status: { $set: 'success' },
      });

    case SignUpActionTypes.SIGNUP_FAILED:
      return update(state, {
        status: { $set: 'failed' },
        errorMessage: { $set: action.error.message },
      });

    case SignUpActionTypes.SIGNUP_RESET:
      return update(state, {
        status: { $set: initialState.status },
      });

    case ConfirmCodeActionTypes.CONFIRM_CODE:
      return update(state, {
        status: { $set: 'loading' },
        codeErrorMessage: { $set: initialState.codeErrorMessage },
      });

    case ConfirmCodeActionTypes.CONFIRM_CODE_SUCCEEDED:
      return update(state, {
        status: { $set: 'success' },
      });

    case ConfirmCodeActionTypes.CONFIRM_CODE_FAILED:
      return update(state, {
        status: { $set: 'failed' },
        codeErrorMessage: { $set: action.error.message },
      });

    case SignInActionTypes.SIGNIN:
      return update(state, {
        status: { $set: 'loading' },
        signInErrorMessage: { $set: null },
      });

    case SignInActionTypes.SIGNIN_SUCCEEDED:
      return update(state, {
        status: { $set: 'success' },
        session: { $set: action.result.session },
      });

    case SignInActionTypes.SIGNIN_FAILED:
      return update(state, {
        status: { $set: 'failed' },
        signInErrorMessage: { $set: action.signInError.message },
      });

    case SignOutActionTypes.SIGNOUT_TOGGLE:
      return update(state, {
        isSignOutButton: { $set: !state.isSignOutButton },
      });

    case SignOutActionTypes.SIGNOUT_SUCCEEDED:
      return update(state, {
        status: { $set: 'success' },
        session: { $set: null },
        isSignOutButton: { $set: null },
      });

    case SignOutActionTypes.SIGNOUT_FAILED:
      return update(state, {
        status: { $set: 'failed' },
        signOutErrorMessage: { $set: action.error.message },
      });

    case PasswordForgotActionTypes.PASSWORD_FORGOT:
      return update(state, {
        status: { $set: 'loading' },
        passwordForgotErrorMessage: { $set: initialState.passwordForgotErrorMessage },
      });

    case PasswordForgotActionTypes.PASSWORD_FORGOT_SUCCEEDED:
      return update(state, {
        status: { $set: 'success' },
      });

    case PasswordForgotActionTypes.PASSWORD_FORGOT_FAILED:
      return update(state, {
        status: { $set: 'failed' },
        passwordForgotErrorMessage: { $set: action.error.message },
      });

    case ConfirmPasswordActionTypes.PASSWORD_CONFIRM:
      return update(state, {
        status: { $set: 'loading' },
        confirmPasswordErrorMessage: { $set: initialState.confirmPasswordErrorMessage },
      });

    case ConfirmPasswordActionTypes.PASSWORD_CONFIRM_SUCCEEDED:
      return update(state, {
        status: { $set: 'success' },
      });

    case ConfirmPasswordActionTypes.PASSWORD_CONFIRM_FAILED:
      return update(state, {
        status: { $set: 'failed' },
        confirmPasswordErrorMessage: { $set: action.error.message },
      });

    case GetSessionActionTypes.GET_SESSION:
      console.log('get session request!');
      return { ...state };

    case GetSessionActionTypes.GET_SESSION_SUCCEEDED:
      return state.session
        ? state
        : update(state, {
          email: { $set: action.email },
          session: { $set: action.session },
          });

    default:
      return state;
  }
}
